import { FunctionComponent, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import useConnectRequest from '../../hooks/useConnectRequest'
import { requestActions } from '../../redux/requests'
import { FETCH_DOCUMENT } from '../../redux/requests/products/product.actions'
import * as S from './styled'
import { useParams } from 'react-router-dom'
import UpdateEggDocument from '../../components/organisms/UpdateEggDocument'
import { getAuth } from 'firebase/auth'
import { Product } from '../DashBoard/DashBoardScreen'

type OwnProps = {}

type Props = OwnProps

export const UpdateDocument: FunctionComponent<Props> = () => {
  const dispatch = useDispatch()
  const { docId } = useParams<{ docId: string }>()
  const auth = getAuth()
  const userId = auth.currentUser?.uid ?? ''
  const { data: doc, loading } = useConnectRequest(FETCH_DOCUMENT, { multiple: false })

  const [product, setProduct] = useState('')
  useEffect(() => {
    if (!doc) {
      dispatch(requestActions.products.fetchDocument(userId, docId, Product.EGG))
    }

    if (doc && !loading) {
      setProduct(doc.product)
    }
  }, [doc])

  return <S.Container>{doc && product === 'eggs' && <UpdateEggDocument doc={doc} />}</S.Container>
}

export default UpdateDocument
